__turbopack_context__.v({
  "container": "MarketplaceV3FaqSection-module-scss-module__mqfeQq__container",
  "title": "MarketplaceV3FaqSection-module-scss-module__mqfeQq__title",
});
